import { ReactLocation } from '@tanstack/react-location';
import { QueryClient, QueryClientProvider } from 'react-query';
import env from '@frontend/env';
import { ThemeProvider, AlertsProvider } from '@frontend/design-system';
import '@design-system/tokens';
import { Main } from './components/main';
import { RoutesProvider } from './providers/routes.provider';
import { unregister } from './utils/registerServiceWorker';

declare global {
  interface Window {
    Cypress?: any;
  }
}

// This is used in auth and routing
const location = new ReactLocation({});
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

// Conditional loading on ENV, is set in the loader function
if (import.meta.env.MODE === 'production') {
  import('./third-party-scripts').then(({ loadThirdPartyScripts }) => {
    loadThirdPartyScripts();
  });
} else {
  console.warn('Third party scripts are not loaded because the app is not running in production.');
}

export default function Root() {
  console.log('version: - ', env.VERSION);
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider includeEmotionTheme skipAnimation={!!window?.Cypress}>
        <AlertsProvider>
          <RoutesProvider>
            <Main location={location} />
          </RoutesProvider>
        </AlertsProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

// For now, we are opting out of using the service worker
// We could change this for production later if we want the improved performance
unregister();
